import React from 'react';
import './Error.css';

const Error = () => {
    return (
        <div className='error'>
            <p className="fs-1">Not Found</p>
        </div>
    );
};

export default Error;